<div class="wrap">
  <div
    [appBackgroundImage]="product.photos[0] | productImage | async"
    [class.no-image]="product.photos.length < 1"
    class="img"
  ></div>
  <div class="details">
    <div class="name">{{ product.name }}</div>
    <div class="price">
      <app-price-label
        [value]="product | getRelevantProductPrice | appCurrency | async"
        [isCompact]="true"
        [noIcon]="true"
      ></app-price-label>
    </div>
  </div>
  <div class="controls">
    <div
      *ngIf="cartQuantity === 0"
      class="add-btn"
      (click)="productAdded.next(product)"
    >+</div>
    <div *ngIf="cartQuantity > 0" class="quantity-selector">
      <app-quantity-selector
        [min]="0"
        [max]="99"
        [value]="cartQuantity"
        (valueDecreased)="productAmountDecreased.next(product.id)"
        (valueIncreased)="productAmountIncreased.next(product.id)"
        [isCompact]="true"
        [isVertical]="true"
      ></app-quantity-selector>
    </div>
  </div>
</div>
